{
  "id": "campaign-097",
  "name": "Foggy Lane",
  "seed": "campaign:97",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".,..L__L....",
    ",L,..__...L.",
    ".,..x__.....",
    ".i.i.__.i.i.",
    ".....__.....",
    "..%..__...X.",
    ".%%%.__x.#..",
    "..%..__,.,..",
    "....,__,,,..",
    ".i.i,__,i,i.",
    "....,__..,..",
    "....T__T,.,.",
    ".i.i.__.i,i.",
    ".....__.....",
    "X...i__i.%..",
    "..X..__..%%.",
    ".......X.%..",
    "x..X.......S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 13
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 17
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "falls": [
    {
      "x": 10,
      "y": 5,
      "dir": "S",
      "at": 15,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 97,
  "biome": "cemetery",
  "par": {
    "reel": 8268,
    "push": 6652,
    "selfPropelled": 6108,
    "tractor": 5090,
    "zeroTurn": 4034,
    "fairway": 3218
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 12,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 11,
      "fairway": 22
    }
  }
}
